import moment from 'moment'

// Fixed identity colours: a provider keeps its colour whatever is filtered
export const PROVIDER_COLORS = { deepgram: '#eb6834', gemini: '#2a78d6' }
export const PROVIDER_LABELS = { deepgram: 'Deepgram', gemini: 'Gemini' }
export const SERIES = { blue: '#2a78d6', orange: '#eb6834', aqua: '#1baf7a' }
export const GRID = '#e6e5e0'
export const AXIS_TEXT = '#52514e'

export const providerLabel = (p) => PROVIDER_LABELS[p] || p
export const providerColor = (p) => PROVIDER_COLORS[p] || '#8a8984'

/** USD: more decimals for small amounts so tiny AI costs don't show as $0.00 */
export const usd = (v, digits) => {
  const n = Number(v || 0)
  const d = digits ?? (n !== 0 && Math.abs(n) < 0.01 ? 6 : n < 1 ? 4 : 2)
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: Math.min(d, 2), maximumFractionDigits: d })}`
}
export const num = (v, digits = 0) => Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: digits })
export const compact = (v) => Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(v || 0)
export const shortDate = (d) => moment(d, 'YYYY-MM-DD').format('DD MMM')
export const longDate = (d) => moment(d, 'YYYY-MM-DD').format('ddd, DD MMM YYYY')
export const dateTime = (d) => (d ? moment(d).format('DD MMM YYYY, hh:mm A') : '-')
/** UTC, so request times/dates match the Deepgram console (which shows UTC) */
export const utcDateTime = (d) => (d ? moment.utc(d).format('DD MMM YYYY, hh:mm A') : '-')
export const duration = (seconds) => {
  const s = Math.round(Number(seconds || 0))
  if (!s) return '-'
  const m = Math.floor(s / 60)
  return m ? `${m}m ${String(s % 60).padStart(2, '0')}s` : `${s}s`
}
export const axisUsd = (v) => (v === 0 ? '$0' : Math.abs(v) < 1 ? `$${Number(v).toFixed(2)}` : `$${compact(v)}`)
